import PropTypes from 'prop-types';

import { Field, ErrorMessage, FieldProps } from 'formik';
import { FiEdit } from 'react-icons/fi';

interface FormFieldProps {
    name: string;
    type: string;
    label: string;
    autocomplete?: string;
    children?: ({ field }: FieldProps<string>) => JSX.Element;
    disabled?: boolean;
    showLabel?: boolean;
    placeHolderText?: string;
    onClickUpdateIcon?: () => void;
    extraInfo?: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({
    name,
    type,
    autocomplete = 'on',
    label,
    children,
    disabled,
    showLabel = true,
    placeHolderText = '',
    onClickUpdateIcon,
    extraInfo,
}) => {
    return (
        <>
            <div className={`form-group ${!showLabel ? 'mt-n2' : ''}`}>
                {type !== 'hidden' && showLabel && (
                    <label htmlFor={name} className="font-weight-bold text-sm mb-1">
                        {label}
                    </label>
                )}

                {onClickUpdateIcon ? (
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                <FiEdit
                                    cursor="pointer"
                                    onClick={onClickUpdateIcon}
                                    title="Update"
                                    color="red"
                                ></FiEdit>
                            </div>
                        </div>
                        <Field
                            className="form-control"
                            name={name}
                            type={type}
                            disabled={!!disabled}
                            placeholder={placeHolderText}
                        >
                            {children}
                        </Field>
                    </div>
                ) : (
                    <Field
                        className="form-control"
                        name={name}
                        type={type}
                        autoComplete={autocomplete}
                        disabled={!!disabled}
                        placeholder={placeHolderText}
                    >
                        {children}
                    </Field>
                )}

                <ErrorMessage className="field-error-feedback" component="div" name={name} />
                <small className="text-extra-small">{extraInfo}</small>
            </div>
        </>
    );
};

FormField.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    children: PropTypes.func,
    disabled: PropTypes.bool,
    showLabel: PropTypes.bool,
    placeHolderText: PropTypes.string,
    onClickUpdateIcon: PropTypes.func,
    extraInfo: PropTypes.element,
};

export default FormField;
